import { ThemeProvider, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';

const SidenavTheme = ({ children }) => {
  const theme = useTheme();
  const settings = useSelector(store=>store.settings);

  const sidenavTheme = settings.themes[settings.layout1Settings.leftSidebar.theme] || theme;

  return <ThemeProvider theme={sidenavTheme}>{children}</ThemeProvider>;
};

export default SidenavTheme;
